import { useSelector } from "react-redux";

export function useIsWarningOmitted(props) {
  const { id } = props;
  const omittedWarnings = useSelector((rootState) => rootState.warningOmissions).list;
  return omittedWarnings.includes(id);
}
